import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-1.5 w-full mb-2 text-xs font-medium text-parameter-text" }

import {useI18n} from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3MostSelected',
  setup(__props) {


const {t} = useI18n();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      class: "w-4 h-4 shrink-0 text-brand-main"
    }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z",
        "clip-rule": "evenodd"
      })
    ], -1)),
    _createTextVNode(" " + _toDisplayString(_unref(t)('components.parameters.mostSelected')), 1)
  ]))
}
}

})